import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";
import React from "react";

function PointerEvents({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"none"} value={""}>
          None
        </MenuItem>,
        <MenuItem key={"No events"} value={"none"}>
          No click/tap interaction
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSPointerEventsComponent: JSInputComponent = {
  Component: PointerEvents,
  handlesCssProperties: ["pointerEvents"],
};
